import { Mapper } from "../../../../../base/utils/mapper";
import { CollaboratorModel } from "../../../../../domain/models/configuration/company/collaborator.model";
import { CollaboratorEntity } from "../../entities/company/collaborator.entity";

export class CololaboratorImplementationRepositoryMapper extends Mapper<CollaboratorEntity, CollaboratorModel> {
    mapFrom(param: CollaboratorEntity): CollaboratorModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CollaboratorModel): CollaboratorEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}